import React from 'react'
import PhoneNumberInput from '../../pb_phone_number_input/_phone_number_input'

const PhoneNumberInputDefault = (props) => (
    <>
        <PhoneNumberInput
            id='default'
            {...props} />
    </>
)

export default PhoneNumberInputDefault
